import { domain } from 'modules/data';
import moment from 'moment';

export const budgetPeriodToDate = (value: domain.BudgetPeriod | undefined) =>
    value
        ? moment
              .utc({
                  year: value.year,
                  month: value.month - 1,
              })
              .toDate()
        : undefined;

export const dateToBudgetPeriod = (date: Date | undefined) =>
    date
        ? {
              month: date.getMonth() + 1,
              year: date.getFullYear(),
          }
        : undefined;
